import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';
import Table from "../../../core/common/dataTable/index";
import AXIOSCONFIGMETHOD from '../../../Axios/axiosConfigMethod';
import { webServiceUrl } from '../../../core/api_utils/webserviceUrl';
import Loading from '../../../core/common/custom-loading/Loading';


type BandType = {
    ID: string,
    band: string,
    status: string
}

const LeadAccActivity = () => {
    const [loading, setLoading] = useState(false)
    const [allItemList, setAllItemList] = useState<any[]>([])


    const columns = [
        {
            title: "Sr No.",
            dataIndex: "SrNo",
            render: (text: string, record: any, index: number) => (
                <h6 className="fw-medium fs-14 text-dark">{index + 1}</h6>
            ),
            sorter: false,
        },
        {
            title: "Activity",
            dataIndex: "activity_name",
            render: (text: string, record: any,) => (
                <p className="fw-medium fs-14 text-dark" style={{ width: "max-content" }}>{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.activity_name || "").localeCompare(b.activity_name || ""),
        },
        {
            title: "Param Type",
            dataIndex: "param_type",
            render: (text: string, record: any,) => (
                <p className="" style={{ width: "" }}>{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.param_type || "").localeCompare(b.param_type || ""),
        },
        // {
        //     title: "Param Value",
        //     dataIndex: "phone_number",
        //     render: (text: string, record: any,) => (
        //         <p className="" style={{ width: "" }}>{text ?? "-"}</p>
        //     ),
        //     sorter: (a: any, b: any) => (a.phone_number || "").localeCompare(b.phone_number || ""),
        // },
        {
            title: "Created At",
            dataIndex: "created_on",
            render: (text: string, record: any,) => (
                <p className="" style={{ width: "" }}>{text?.split("T")[0] ?? "-"}</p>
            ),
            sorter: (a: any, b: any) =>
                new Date(a.created_on || "").getTime() - new Date(b.created_on || "").getTime(),
        },
        // {
        //     title: "Action",
        //     dataIndex: "actions",
        //     render: (_: any, record: any) => (
        //         <div className="action-icon d-inline-flex">
        //             <Link
        //                 to="#"
        //                 className="me-2"
        //             >
        //                 <i className="ti ti-edit" />
        //             </Link>
        //             <Link
        //                 to="#"
        //             >
        //                 <i className="ti ti-trash" />
        //             </Link>
        //         </div>
        //     ),
        // },
    ];

    const fetchData = async () => {
        try {
            setLoading(true)
            const resp = await AXIOSCONFIGMETHOD("get", webServiceUrl.GET_LEAD_ACCOUNT_ACTIVITY);
            console.log("resp Lead account activity", resp)
            if (resp?.data?.status) {
                const final = resp?.data?.data;
                setAllItemList(final?.length > 0 && final);
            }
        } catch (error) {
            console.error("Error fetching  data:", error);
        } finally {
            setTimeout(() => setLoading(false), 500);
        }
    };
    useEffect(() => {
        fetchData()
    }, [])

    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Lead Account Activity</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.adminDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Dashboard
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        All Lead Account Activity
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            {/* <div className="mb-2">
                                <button
                                    className="btn btn-primary d-flex align-items-center"
                                    disabled={loading}
                                >
                                    <i className="ti ti-circle-plus me-2" />
                                    Add New Band
                                </button>
                            </div> */}
                        </div>
                    </div>
                    {/* /Breadcrumb */}
                    {/* Performance Indicator list */}
                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                            <h5>Lead Account Activity List</h5>
                        </div>
                        <div className="card-body p-0">
                            {loading
                                ? <Loading />
                                : <Table dataSource={allItemList} columns={columns} Selection={false} />
                            }
                        </div>
                    </div>
                    {/* /Performance Indicator list */}
                </div>
                <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
               <p className="mb-0">© {new Date().getFullYear()} Nestfin Technology. All rights reserved.</p>
                </div>
            </div>
            {/* /Page Wrapper */}
        </>
    )
}

export default LeadAccActivity;
